export const categories = [
  { key: "all", name: "全部瓜田", icon: "ri-dashboard-line", desc: "所有正在被围观的热门事件" },
  { key: "ent", name: "娱乐圈", icon: "ri-movie-2-line", desc: "镜头前后的名场面与网友反应" },
  { key: "society", name: "社会热点", icon: "ri-building-2-line", desc: "街头巷尾的暖心事与真性情" },
  { key: "life", name: "日常生活", icon: "ri-cup-line", desc: "普通人的日子最有看头" },
  { key: "tech", name: "科技数码", icon: "ri-cpu-line", desc: "发布会、代码与网友脑洞" },
  { key: "sports", name: "体育赛事", icon: "ri-basketball-line", desc: "赛场内外的解说与弹幕" },
];

export const events = [
  {
    id: "airport-shy-moment",
    title: "明星机场低头快走被喊“社恐本人”，评论区集体玩梗停不下来",
    category: "ent",
    categoryName: "娱乐圈",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20crowded%20airport%20hall%2C%20people%20with%20suitcases%20walking%20fast%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20clean%20minimal%20editorial%20vector%20style%2C%20soft%20grain%20texture%2C%20no%20text&width=800&height=600&seq=gossip-cover-airport-01&orientation=landscape",
    summary:
      "一位艺人在机场被拍到低头快走，本想低调，没想到一句现场喊话把整件事变成了全民玩梗现场，评论区的高赞神回复一条接一条。",
    heat: 98244,
    commentCount: 1863,
    publishedAt: "2026-09-08",
    readTime: "4 分钟",
    author: "瓜田观察员",
    tags: ["机场名场面", "社恐梗", "高赞评论"],
    content: [
      "事情起因很简单：一段十几秒的机场路透里，这位艺人帽子压得很低，全程低头快走，脚步明显比别人快半拍，被旁边一位路人笑着喊了一句“走这么急，是社恐本人吧”。",
      "这段视频原本只是粉丝小范围转发，真正让它出圈的是评论区。有人把这段步伐形容为“末班地铁冲刺”，也有人认真分析帽子角度和步频的对应关系，硬是给这一分钟配了一篇小作文。",
      "最有意思的是，大家并没有把话题停留在当事人身上，而是迅速转向“我社恐时的样子”大型自曝现场：见人就绕路、电梯里假装看手机、买单只敢用扫码。一个机场路透，最后变成了上万人的共鸣征集。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "甜度超标研究所",
        content: "他不是社恐，他是怕被认出来之后要被迫社交，这两种痛苦我一天要经历三次。",
        likes: 12873,
        time: "2小时前",
        isHot: true,
        replies: [
          { nickname: "含糖量警告", content: "最后一句太真实了，打工人的痛。" },
          { nickname: "路过围观", content: "建议出书：《社恐的自我修养》。" },
        ],
      },
      {
        id: "c2",
        nickname: "末班地铁常客",
        content: "这个步频我熟，就是那种“再慢一秒就要被搭话”的极限速度。",
        likes: 8421,
        time: "3小时前",
        isHot: true,
        replies: [{ nickname: "赶车第一名", content: "精髓在于肩膀还要微微缩起来。" }],
      },
      {
        id: "c3",
        nickname: "冷静吃瓜第一人",
        content: "全场最勇的还是喊话那位路人，属于是替我们说了不敢说的话。",
        likes: 5310,
        time: "4小时前",
        isHot: false,
        replies: [],
      },
      {
        id: "c4",
        nickname: "帽子收藏家",
        content: "重点难道不是这顶帽子吗？压这么低还能走直线，方向感比导航还准。",
        likes: 3987,
        time: "5小时前",
        isHot: false,
        replies: [{ nickname: "路痴现身", content: "我压这么低早就撞柱子了。" }],
      },
    ],
  },
  {
    id: "subway-warm-words",
    title: "地铁上陌生人只说了一句话，整节车厢的人都笑了",
    category: "society",
    categoryName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20subway%20carriage%20interior%20with%20diverse%20passengers%20smiling%2C%20soft%20amber%20and%20teal%20accent%20colors%2C%20clean%20minimal%20editorial%20vector%20style%2C%20gentle%20shadows%20and%20grain%20texture%2C%20no%20text&width=800&height=600&seq=gossip-cover-subway-02&orientation=landscape",
    summary:
      "晚高峰地铁里，一位乘客的一句话让原本沉闷的车厢集体笑出声。网友把这段偶遇写出来之后，评论区开始分享自己被陌生人治愈的瞬间。",
    heat: 76310,
    commentCount: 1240,
    publishedAt: "2026-09-07",
    readTime: "3 分钟",
    author: "街头观察",
    tags: ["暖心瞬间", "陌生人善意", "网友热评"],
    content: [
      "晚高峰的地铁通常只有一个表情：疲惫。但有人在社交平台记录了一段不一样的车厢——一位大叔上车后看了一圈，笑着说“今天大家都辛苦了，站着的我记住了，坐着的我羡慕了”，车厢里先是安静两秒，接着笑成一片。",
      "发帖网友写道，那一刻他本来刚被领导批评完，情绪低落到了极点，结果没绷住笑了出来。“我发现原来快乐真的可以传染，而且成本这么低。”",
      "帖子下很快聚起了另外一群人，他们分享的都是同类型的小事：便利店店员多给的一颗糖、公交车司机多等的那五秒、外卖备注里手写的一句“天冷慢点吃”。这些瞬间都很小，但被记录下来之后，分量意外地重。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "今天的我也很困",
        content: "成年人的崩溃是安静的，成年人的治愈也是安静的，就是这种一句话的事。",
        likes: 9642,
        time: "6小时前",
        isHot: true,
        replies: [
          { nickname: "深夜emo选手", content: "看着看着就有点想哭，可能是最近太累了。" },
          { nickname: "暖气片本片", content: "这条评论建议裱起来。" },
        ],
      },
      {
        id: "c2",
        nickname: "通勤两小时",
        content: "我上次在地铁里笑出声，是因为旁边小孩指着广告牌说“妈妈这个叔叔头发好少”，当事人就在他旁边站着。",
        likes: 7120,
        time: "7小时前",
        isHot: true,
        replies: [{ nickname: "头发还健在", content: "请问你礼貌吗（捂脸）" }],
      },
      {
        id: "c3",
        nickname: "慢半拍星人",
        content: "原来不是我运气好才总遇到好人，是这种小事本来就每天都在发生，只是我们没记下来。",
        likes: 4890,
        time: "8小时前",
        isHot: false,
        replies: [],
      },
    ],
  },
  {
    id: "delivery-note",
    title: "外卖备注里的手写留言火了，这届网友的温柔真的藏不住",
    category: "society",
    categoryName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20flat%20illustration%20of%20a%20takeaway%20paper%20bag%20with%20a%20small%20handwritten%20note%2C%20warm%20coral%20and%20cream%20palette%2C%20clean%20minimal%20editorial%20vector%20style%2C%20soft%20texture%2C%20no%20text&width=800&height=600&seq=gossip-cover-delivery-03&orientation=landscape",
    summary:
      "一张写着“天冷，路上慢点”的外卖备注截图被大量转发。看似普通的一句话，评论区却刷出了几千条相似的温柔。",
    heat: 64120,
    commentCount: 998,
    publishedAt: "2026-09-06",
    readTime: "3 分钟",
    author: "生活采集站",
    tags: ["外卖备注", "陌生善意", "评论区名场面"],
    content: [
      "截图来自一位外卖骑手，他收到订单时发现备注栏里多了一句和订单无关的话：“天冷，路上慢点，超时也没关系。”他说自己跑了三年外卖，第一次因为一条备注在楼下站了半分钟。",
      "帖子发出后，评论区变成了大型“备注展览”。有人写“不用敲门，放门口就好，辛苦了”，有人写“下雨天不着急，安全第一”，还有人写“餐可以凉，你不能受伤”。",
      "有意思的是，不少网友开始反思自己：以前催单时语气很冲，看完这些备注之后，默默把输入框里的“怎么还没到”删掉了。一条随手写的备注，最后改变的可能是一整天的情绪。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "点单从不催",
        content: "我一直以为我备注“慢点没关系”是客套，看到这条才知道，对方真的会记很久。",
        likes: 6320,
        time: "1天前",
        isHot: true,
        replies: [{ nickname: "骑手家属", content: "替同行谢谢你，这句话真的有用。" }],
      },
      {
        id: "c2",
        nickname: "雨天不打伞",
        content: "最戳我的是“餐可以凉，你不能受伤”，这句话的温柔是有重量的。",
        likes: 5108,
        time: "1天前",
        isHot: true,
        replies: [],
      },
      {
        id: "c3",
        nickname: "深夜加餐人",
        content: "我写备注喜欢加一句“不用按门铃”，结果有次对方还是轻轻敲了两下，说怕我一个人在家不安全。",
        likes: 3421,
        time: "1天前",
        isHot: false,
        replies: [{ nickname: "独居青年", content: "这个细节真的会记很久。" }],
      },
    ],
  },
  {
    id: "classroom-note",
    title: "大学生在教室捡到一张纸条，内容让全网笑到打鸣",
    category: "life",
    categoryName: "日常生活",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20flat%20illustration%20of%20a%20university%20lecture%20hall%20desk%20with%20a%20folded%20paper%20note%2C%20amber%20and%20cream%20palette%20with%20coral%20accents%2C%20clean%20minimal%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=gossip-cover-classroom-04&orientation=landscape",
    summary:
      "一张被遗落在教室座位上的纸条，写着“如果你看到这行字，说明我翘课了，麻烦帮我占一下”。楼主的后续曝光让评论区彻底沸腾。",
    heat: 58760,
    commentCount: 877,
    publishedAt: "2026-09-05",
    readTime: "3 分钟",
    author: "校园吃瓜站",
    tags: ["校园名场面", "神回复", "年轻人日常"],
    content: [
      "楼主在自习教室收拾东西时，发现桌肚里塞着一张对折的纸条，展开后第一行是：“如果你看到这行字，说明我翘课了，麻烦帮我占一下。”",
      "第二行更绝：“占座费是一包辣条，就在我桌板下面，自取，别客气。”楼主翻了翻，桌板下居然真的压着一包没拆封的辣条。",
      "帖子发出来后，评论区瞬间变成了“当代大学生交际礼仪研讨现场”。有人夸这是契约精神，有人认真讨论辣条的品牌和价位的匹配度，还有人开始复盘自己这些年白占的座。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "占座专业户",
        content: "这已经不是占座了，这是校园范围内的劳动关系确立。",
        likes: 7455,
        time: "2天前",
        isHot: true,
        replies: [
          { nickname: "劳动法在读", content: "辣条属于实物对价，合法有效。" },
          { nickname: "室友本人", content: "笑死，我们宿舍也这么干过。" },
        ],
      },
      {
        id: "c2",
        nickname: "辣条鉴定师",
        content: "重点是人家真的留了辣条，我在食堂被拜托占座，回报是一句“下次请你喝奶茶”，至今没等到下次。",
        likes: 5233,
        time: "2天前",
        isHot: true,
        replies: [{ nickname: "奶茶欠债人", content: "对不起，我可能是你同学。" }],
      },
      {
        id: "c3",
        nickname: "毕业三年了",
        content: "看评论才想起来，我大学也干过这事，纸条上写的是“帮我看书，人可以有事先走”。",
        likes: 2984,
        time: "2天前",
        isHot: false,
        replies: [],
      },
    ],
  },
  {
    id: "phone-launch-roast",
    title: "新机发布会变成吐槽大会，网友脑洞比产品本身还精彩",
    category: "tech",
    categoryName: "科技数码",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20a%20smartphone%20launch%20stage%20with%20spotlights%20and%20floating%20app%20icons%2C%20teal%20and%20coral%20palette%2C%20clean%20minimal%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=gossip-cover-launch-05&orientation=landscape",
    summary:
      "一场发布会结束后，真正上热搜的不是参数，而是网友的段子。从命名规则到配色，评论区把能吐槽的地方一个都没放过。",
    heat: 51980,
    commentCount: 764,
    publishedAt: "2026-09-04",
    readTime: "4 分钟",
    author: "数码围观局",
    tags: ["发布会", "数码吐槽", "高赞评论"],
    content: [
      "发布会长达两小时，台上讲参数、讲工艺、讲影像，台下网友已经给新品取好了三个外号。有人根据配色命名，有人根据价格命名，还有热心网友把近三年的命名规律整理成了时间线。",
      "最热闹的讨论集中在“这次升级值不值得换”。有人甩出账单说能再战两年，也有人说自己上次说这句话时用的还是三年前的机型。",
      "有趣的是，吐槽归吐槽，评论区里认真做对比的也不少：续航、影像、重量，一条条列得比发布会 PPT 还清楚。热闹和理性在同一个评论区里居然相处得很好。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "等等党永不服输",
        content: "我建议大家再等等，等下一代，等下一代发布了再等下一代，我这样已经等了五年了。",
        likes: 6120,
        time: "3天前",
        isHot: true,
        replies: [
          { nickname: "等等党会长", content: "欢迎加入组织，我们的口号是：永远在路上。" },
          { nickname: "已经下单了", content: "不好意思，我叛变了。" },
        ],
      },
      {
        id: "c2",
        nickname: "逐帧比对哥",
        content: "别人看发布会看产品，我看发布会看提词器，全程只关心他有没有卡壳。",
        likes: 4302,
        time: "3天前",
        isHot: true,
        replies: [],
      },
      {
        id: "c3",
        nickname: "理性消费提醒",
        content: "说真的，这次影像提升是真的有，但如果你上代旗舰，其实没必要年年换，钱留着吃好吃的。",
        likes: 3890,
        time: "3天前",
        isHot: false,
        replies: [{ nickname: "被说服了", content: "谢谢，钱包替我谢谢你。" }],
      },
    ],
  },
  {
    id: "commentator-slip",
    title: "解说员一句口误冲上热搜，弹幕比比赛本身还激烈",
    category: "sports",
    categoryName: "体育赛事",
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20flat%20illustration%20of%20a%20stadium%20with%20crowd%20and%20scoreboard%2C%20amber%20and%20teal%20palette%20with%20coral%20highlights%2C%20clean%20minimal%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=gossip-cover-sports-06&orientation=landscape",
    summary:
      "比赛进行到加时赛，解说员一句口误让直播间弹幕瞬间刷屏。赛后复盘时，大家发现那场比赛的弹幕比集锦还好看。",
    heat: 47330,
    commentCount: 690,
    publishedAt: "2026-09-03",
    readTime: "3 分钟",
    author: "赛场围观席",
    tags: ["解说名场面", "弹幕文化", "赛事热评"],
    content: [
      "加时赛最后两分钟，解说员语速拉满，把球员名字和号码连着念错两次，自己还没反应过来，继续激情输出。等他意识到的时候，弹幕已经把这句话做成了口号。",
      "比赛结束后，官方集锦下面的评论区分成了几派：一派只讨论战术和轮换，一派专攻解说口误的衍生段子，还有一派负责把两件事结合起来，用战术分析的口吻解释那句口误。",
      "有人总结得很到位：“比赛也就四十八分钟，但评论区能看一整个晚上。”这大概就是体育氛围最迷人的部分——输赢紧张，看热闹的人也没闲着。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "解说宽容协会",
        content: "念错名字算什么，他上一场还把我主队叫成了同城的另一支队，我当场笑出声。",
        likes: 5320,
        time: "4天前",
        isHot: true,
        replies: [{ nickname: "同城另一队球迷", content: "谢谢，我们也很尴尬。" }],
      },
      {
        id: "c2",
        nickname: "战术板本板",
        content: "别笑解说，加时赛最后两分钟，我坐在电视前也念不清我自己的名字。",
        likes: 4108,
        time: "4天前",
        isHot: true,
        replies: [],
      },
      {
        id: "c3",
        nickname: "只看集锦",
        content: "看比赛看的是心跳，看评论区看的是快乐，两者缺一不可。",
        likes: 2674,
        time: "4天前",
        isHot: false,
        replies: [],
      },
    ],
  },
  {
    id: "matchmaking-uncle",
    title: "相亲角大叔的一句话被记进“年度神回复”，围观群众直呼太敢说",
    category: "society",
    categoryName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20flat%20illustration%20of%20a%20leafy%20city%20park%20with%20notice%20boards%20and%20benches%2C%20warm%20amber%20and%20cream%20palette%20with%20coral%20details%2C%20clean%20minimal%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=gossip-cover-park-07&orientation=landscape",
    summary:
      "周末的公园相亲角，一位大叔面对提问时给出的回答被路人录了下来。短短一句话，评论区却讨论出了几个回合。",
    heat: 43920,
    commentCount: 612,
    publishedAt: "2026-09-02",
    readTime: "3 分钟",
    author: "街头观察",
    tags: ["相亲角", "神回复", "社会观察"],
    content: [
      "视频里的提问很常规：为什么对条件卡得这么细。大叔想了想说：“我们不是挑剔，是怕孩子将来跟不合适的人过一辈子，比现在还累。”",
      "这句话被上传后，评论区第一次没有吵起来。有年轻人说，听惯了“为你好”三个字，第一次听到有人把背后的担心说得这么具体。",
      "当然，也少不了犀利点评。有人指出，担心归担心，孩子的选择权还是要还给他们；也有人说，代际之间最大的问题从来不是爱不够，而是表达方式对不上。一个相亲角的小片段，最后聊成了两代人的沟通课。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "被催婚第八年",
        content: "\"怕孩子过得更累\"这句我信，但爸妈可以换一种表达，比如先问我今天累不累。",
        likes: 4870,
        time: "5天前",
        isHot: true,
        replies: [
          { nickname: "即将当爸的人", content: "说得真好，记下来以后提醒自己。" },
          { nickname: "路过的阿姨", content: "我们那代人真的不太会说话。" },
        ],
      },
      {
        id: "c2",
        nickname: "周末去遛弯",
        content: "我在现场，大叔说完之后旁边几位家长都沉默了，那一瞬间比任何辩论都真实。",
        likes: 3560,
        time: "5天前",
        isHot: true,
        replies: [],
      },
      {
        id: "c3",
        nickname: "和事佬本佬",
        content: "其实两边都没错，只是都太在乎了，所以话越说越硬。",
        likes: 2430,
        time: "5天前",
        isHot: false,
        replies: [],
      },
    ],
  },
  {
    id: "variety-reaction",
    title: "综艺名场面被做成表情包，嘉宾的一个反应让网友笑了一整周",
    category: "ent",
    categoryName: "娱乐圈",
    cover:
      "https://readdy.ai/api/search-image?query=Cheerful%20flat%20illustration%20of%20a%20colorful%20tv%20studio%20set%20with%20sofa%20and%20stage%20lights%2C%20coral%20amber%20and%20teal%20palette%2C%20clean%20minimal%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=gossip-cover-variety-08&orientation=landscape",
    summary:
      "一段不到三秒的反应镜头，被网友截成了十几张表情包。评论区开始比拼谁的表情包更贴合日常。",
    heat: 40550,
    commentCount: 588,
    publishedAt: "2026-09-01",
    readTime: "3 分钟",
    author: "瓜田观察员",
    tags: ["综艺名场面", "表情包", "网友热评"],
    content: [
      "那一期综艺里，嘉宾听到某句话之后的表情变化只用了两秒半：先是愣住，然后眉毛挑起来，最后默默把椅子往后挪了半格。整个过程没有一句话，却成了整期节目讨论度最高的片段。",
      "网友的效率惊人，当天晚上就有成套表情包流传，配文从“听到同事涨薪”到“看到月底账单”，几乎覆盖了打工人所有的情绪节点。",
      "有意思的是，节目组后来在采访里提到，那个反应完全是真实的、没有排练过的。这也解释了为什么它能戳中人——真实的东西，永远比设计好的笑点更有传播力。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "表情包收藏癖",
        content: "这个往后挪椅子我太懂了，就是那种“话题危险，我先撤”的求生欲。",
        likes: 4450,
        time: "6天前",
        isHot: true,
        replies: [{ nickname: "职场潜水员", content: "群里有人开始点名的时候我也是这个表情。" }],
      },
      {
        id: "c2",
        nickname: "综艺老观众",
        content: "现在综艺最好看的部分真的不在正片，在评论区的高赞总结。",
        likes: 3320,
        time: "6天前",
        isHot: true,
        replies: [],
      },
    ],
  },
  {
    id: "market-sign",
    title: "菜市场摊主的招牌文案太有才，路人排着队拍照",
    category: "life",
    categoryName: "日常生活",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20bustling%20vegetable%20market%20stall%20with%20colorful%20produce%20and%20signboards%2C%20cream%20amber%20and%20coral%20palette%2C%20clean%20minimal%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=gossip-cover-market-09&orientation=landscape",
    summary:
      "一位摊主把每天的招牌写成了段子，从“今天的菜比昨天老实”到“不甜你带走不要钱”。围观的人越来越多，评论区开始集体呼吁出文案集。",
    heat: 37840,
    commentCount: 520,
    publishedAt: "2026-08-31",
    readTime: "3 分钟",
    author: "生活采集站",
    tags: ["菜市场", "文案高手", "烟火气"],
    content: [
      "这位摊主每天换一次黑板，写的内容几乎没有重复过：卖西红柿写“个个实在，不玩虚的”，卖青菜写“今天有点蔫，价格也蔫”，遇到雨天写“别急，慢慢挑，伞先放我这儿”。",
      "有常客说，来这儿买菜本来只图新鲜，后来变成特意绕路来看当天写了什么。有几行字被人拍了发到网上，第二天摊前就多了不少面生的年轻人。",
      "评论区最热闹的讨论是：这种文案到底能不能学。结论是学不来——因为它的底子是真诚，不是技巧。真正打动人的，永远是那种“我认真在做一件事”的感觉。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "文案从业者",
        content: "我们憋一天憋不出一句 slogan，人家顺手写在黑板上就是满分，服气。",
        likes: 3980,
        time: "1周前",
        isHot: true,
        replies: [{ nickname: "甲方本甲", content: "建议直接来我们公司上班。" }],
      },
      {
        id: "c2",
        nickname: "每天都要吃菜",
        content: "“今天有点蔫，价格也蔫” —— 这哪是卖菜，这是在教我怎么做坦白局。",
        likes: 2874,
        time: "1周前",
        isHot: true,
        replies: [],
      },
      {
        id: "c3",
        nickname: "城市观察日志",
        content: "菜市场的烟火气是最不会过时的内容，可惜大家平时都走得太快了。",
        likes: 2140,
        time: "1周前",
        isHot: false,
        replies: [],
      },
    ],
  },
  {
    id: "code-confession",
    title: "代码里藏了一句情话被同事扒出来，整个技术群集体破防",
    category: "tech",
    categoryName: "科技数码",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20laptop%20screen%20showing%20abstract%20code%20lines%20with%20small%20heart%20shapes%2C%20teal%20and%20coral%20palette%20on%20cream%20background%2C%20clean%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=gossip-cover-code-10&orientation=landscape",
    summary:
      "一次代码评审，同事在注释里发现了一行和生活有关的句子。故事传开后，评论区开始晒自己在文档里留下的“私货”。",
    heat: 34120,
    commentCount: 468,
    publishedAt: "2026-08-30",
    readTime: "3 分钟",
    author: "数码围观局",
    tags: ["程序员日常", "隐藏彩蛋", "网友热评"],
    content: [
      "故事发生在一场普通的代码评审上。有位同事在翻看一段老逻辑时，发现注释里偷偷写着一句话，大意是“这段代码稳定运行了三年，就像我们一样”。",
      "群里一下子沸腾了。有人顺着时间线扒出，那段逻辑正好是作者结婚那段时间写的；也有人认真考证注释的语法是否规范，结论是“不规范，但很浪漫”。",
      "讨论很快蔓延到更广的话题：程序员到底会在代码里藏多少东西。有人晒出变量命名的小心思，有人说自己在文档结尾写过给团队的感谢，还有人坦白藏的是加班时的抱怨，只是后来被自己删掉了。",
    ],
    comments: [
      {
        id: "c1",
        nickname: "注释考古员",
        content: "我上周也扒出来一句“别动这里，动了会出事”，三年了没人敢动，现在它是整个项目最稳的模块。",
        likes: 3560,
        time: "1周前",
        isHot: true,
        replies: [{ nickname: "继承者", content: "这种注释才是真正的祖传代码保护罩。" }],
      },
      {
        id: "c2",
        nickname: "文档写手",
        content: "我在接口文档里写过“请温柔调用”，后来被测试同学截图挂在了群里。",
        likes: 2620,
        time: "1周前",
        isHot: true,
        replies: [],
      },
      {
        id: "c3",
        nickname: "删库跑路预备役",
        content: "浪漫是真的，但注释规范也是真的，建议写成文档别写进业务代码，不然下一个人真的会懵。",
        likes: 1980,
        time: "1周前",
        isHot: false,
        replies: [],
      },
    ],
  },
];

export const topComments = [
  {
    id: "top1",
    eventId: "subway-warm-words",
    eventTitle: "地铁上陌生人只说了一句话，整节车厢的人都笑了",
    nickname: "今天的我也很困",
    content: "成年人的崩溃是安静的，成年人的治愈也是安静的，就是这种一句话的事。",
    likes: 9642,
    date: "2026-09-09",
    categoryName: "社会热点",
  },
  {
    id: "top2",
    eventId: "delivery-note",
    eventTitle: "外卖备注里的手写留言火了，这届网友的温柔真的藏不住",
    nickname: "点单从不催",
    content: "我一直以为我备注“慢点没关系”是客套，看到这条才知道，对方真的会记很久。",
    likes: 6320,
    date: "2026-09-08",
    categoryName: "社会热点",
  },
  {
    id: "top3",
    eventId: "airport-shy-moment",
    eventTitle: "明星机场低头快走被喊“社恐本人”，评论区集体玩梗停不下来",
    nickname: "甜度超标研究所",
    content: "他不是社恐，他是怕被认出来之后要被迫社交，这两种痛苦我一天要经历三次。",
    likes: 12873,
    date: "2026-09-09",
    categoryName: "娱乐圈",
  },
  {
    id: "top4",
    eventId: "classroom-note",
    eventTitle: "大学生在教室捡到一张纸条，内容让全网笑到打鸣",
    nickname: "占座专业户",
    content: "这已经不是占座了，这是校园范围内的劳动关系确立。",
    likes: 7455,
    date: "2026-09-07",
    categoryName: "日常生活",
  },
  {
    id: "top5",
    eventId: "phone-launch-roast",
    eventTitle: "新机发布会变成吐槽大会，网友脑洞比产品本身还精彩",
    nickname: "等等党永不服输",
    content: "我建议大家再等等，等下一代，等下一代发布了再等下一代，我这样已经等了五年了。",
    likes: 6120,
    date: "2026-09-06",
    categoryName: "科技数码",
  },
  {
    id: "top6",
    eventId: "commentator-slip",
    eventTitle: "解说员一句口误冲上热搜，弹幕比比赛本身还激烈",
    nickname: "解说宽容协会",
    content: "念错名字算什么，他上一场还把我主队叫成了同城的另一支队，我当场笑出声。",
    likes: 5320,
    date: "2026-09-05",
    categoryName: "体育赛事",
  },
  {
    id: "top7",
    eventId: "matchmaking-uncle",
    eventTitle: "相亲角大叔的一句话被记进“年度神回复”，围观群众直呼太敢说",
    nickname: "被催婚第八年",
    content: "\"怕孩子过得更累\"这句我信，但爸妈可以换一种表达，比如先问我今天累不累。",
    likes: 4870,
    date: "2026-09-04",
    categoryName: "社会热点",
  },
  {
    id: "top8",
    eventId: "code-confession",
    eventTitle: "代码里藏了一句情话被同事扒出来，整个技术群集体破防",
    nickname: "注释考古员",
    content: "我上周也扒出来一句“别动这里，动了会出事”，三年了没人敢动，现在它是整个项目最稳的模块。",
    likes: 3560,
    date: "2026-09-03",
    categoryName: "科技数码",
  },
];

export const faqs = [
  {
    q: "「瓜田热评」和普通资讯站有什么区别？",
    a: "普通资讯站只讲事件，我们更关心事件下面发生了什么。每条事件都会同步整理评论区的高赞热评、犀利吐槽和神回复，让你既能看热闹，也能看到最有意思的网友态度。",
  },
  {
    q: "网站上的热评是怎么筛选出来的？",
    a: "编辑会综合点赞量、回复活跃度、观点独特性三个维度进行人工复核，尽量把真正有信息量、有观点、有梗的评论挑出来，而不是简单按照点赞数排序。",
  },
  {
    q: "我可以参与互动，表达自己的态度吗？",
    a: "可以。每篇事件详情页都设有围观评论区，你能看到整理好的高赞热评与神回复，并为你认同的观点点个赞同；也欢迎把有意思的现场分享给朋友一起围观。",
  },
  {
    q: "内容更新频率大概是多少？",
    a: "工作日每天更新 3 到 6 条热门事件，周末会根据一周热度做一次合集复盘。重大热点出现时，我们会临时加更实时围观。",
  },
  {
    q: "如何加入吃瓜群，第一时间收到更新？",
    a: "在页面底部或「关于我们」页填写订阅信息，即可加入吃瓜群并订阅瓜田日报。我们会把当天最值得看的事件和神评整理成一封短邮件发给你。",
  },
];